function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5 10C19.5 15.2467 15.2467 19.5 10 19.5C4.75329 19.5 0.5 15.2467 0.5 10C0.5 4.75329 4.75329 0.5 10 0.5C15.2467 0.5 19.5 4.75329 19.5 10Z",
  fill: "#6E7E91",
  stroke: "#6E7E91"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.99989 5.7179C7.63495 5.7179 5.71777 7.63507 5.71777 10C5.71777 12.365 7.63495 14.2821 9.99989 14.2821C12.3648 14.2821 14.282 12.365 14.282 10C14.282 7.63507 12.3648 5.7179 9.99989 5.7179ZM9.99989 13.5V6.50002C11.6617 6.4956 13.0949 7.6667 13.4217 9.29611C13.526 9.75959 13.526 10.2404 13.4217 10.7039C13.0949 12.3334 11.6617 13.5045 9.99989 13.5Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4417 6.55866C13.5139 6.63235 13.6123 6.67449 13.7154 6.67599C13.8186 6.67453 13.917 6.63235 13.9891 6.55866L14.9473 5.60056C15.1201 5.47095 15.155 5.22585 15.0255 5.05306C14.8959 4.88026 14.6508 4.84527 14.478 4.97484C14.4483 4.99707 14.422 5.02341 14.3998 5.05306L13.4416 6.01116C13.2904 6.14986 13.2803 6.38489 13.4191 6.53605C13.4263 6.54391 13.4338 6.55144 13.4417 6.55866Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.48036 13.4415C6.34132 13.3372 6.15011 13.3372 6.01107 13.4415L5.05297 14.3996C4.90177 14.5383 4.89167 14.7733 5.03041 14.9245C5.03759 14.9323 5.04515 14.9399 5.05297 14.9471C5.19167 15.0983 5.42671 15.1084 5.57787 14.9696C5.58573 14.9624 5.59325 14.9549 5.60044 14.9471L6.55854 13.9889C6.68815 13.8162 6.65315 13.5711 6.48036 13.4415Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9471 14.3995L13.989 13.4414C13.8162 13.3118 13.5711 13.3468 13.4415 13.5196C13.3372 13.6587 13.3372 13.8499 13.4415 13.9889L14.3996 14.947C14.5383 15.0982 14.7733 15.1083 14.9245 14.9696C14.9323 14.9624 14.9399 14.9548 14.947 14.947C15.0982 14.8083 15.1083 14.5733 14.9696 14.4221C14.9625 14.4142 14.9549 14.4067 14.9471 14.3995Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M6.01095 6.55866C6.14965 6.70986 6.38468 6.71997 6.53585 6.58123C6.54371 6.57404 6.55123 6.56648 6.55842 6.55866C6.70962 6.41996 6.71972 6.18493 6.58098 6.03377C6.5738 6.02591 6.56624 6.01838 6.55842 6.0112L5.60031 5.0531C5.42752 4.92349 5.18242 4.95852 5.05281 5.13132C4.94854 5.27035 4.94854 5.46156 5.05281 5.6006L6.01095 6.55866Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0004 5.13129C10.2164 5.13129 10.3915 4.95621 10.3915 4.74023V3.39106C10.3915 3.17508 10.2164 3 10.0004 3C9.78445 3 9.60938 3.17508 9.60938 3.39106V4.74023C9.60938 4.95621 9.78445 5.13129 10.0004 5.13129Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0004 14.8688C9.78445 14.8688 9.60938 15.0439 9.60938 15.2598V16.609C9.60938 16.825 9.78445 17.0001 10.0004 17.0001C10.2164 17.0001 10.3915 16.825 10.3915 16.609V15.2598C10.3915 15.0439 10.2164 14.8688 10.0004 14.8688Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M16.6094 9.60901H15.2602C15.0442 9.60901 14.8691 9.78409 14.8691 10.0001C14.8691 10.2161 15.0442 10.3911 15.2602 10.3911H16.6094C16.8254 10.3911 17.0004 10.2161 17.0004 10.0001C17.0004 9.78409 16.8253 9.60901 16.6094 9.60901Z",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M5.13129 10.0001C5.13129 9.78409 4.95621 9.60901 4.74023 9.60901H3.39106C3.17508 9.60901 3 9.78409 3 10.0001C3 10.2161 3.17508 10.3911 3.39106 10.3911H4.74023C4.95621 10.3911 5.13129 10.2161 5.13129 10.0001Z",
  fill: "white"
});

function SvgLightTheme(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightTheme);
export default __webpack_public_path__ + "static/media/lightTheme.9bde318e.svg";
export { ForwardRef as ReactComponent };